import React, { useEffect } from 'react';

type PageTitleProps = {
  title: string;
  children: React.ReactNode;
};

const appName = 'LHPH.ai';

const PageTitle = ({ title, children }: PageTitleProps) => {
  useEffect(() => {
    document.title = `${title} - ${appName}`;
  }, [title]);

  return <>{children}</>;
};

export default PageTitle;
